import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const STORAGE_KEY = "decyzon.cookie_consent.v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setOpen(true), 800);
        return () => clearTimeout(t);
      }
    } catch { /* noop */ }
  }, []);

  const choose = (value: "accepted" | "essential") => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, at: Date.now() })); } catch { /* noop */ }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 280, damping: 28 }}
          className="fixed bottom-[80px] md:bottom-4 left-3 right-3 md:left-auto md:right-4 md:w-[380px] z-[60] rounded-xl border border-border/60 bg-card/95 backdrop-blur-md p-4 shadow-2xl"
          role="dialog"
          aria-label="Cookie consent"
        >
          <p className="text-sm text-foreground font-body font-medium mb-1">Cookies & analytics</p>
          <p className="text-xs text-muted-foreground font-body leading-relaxed mb-3">
            We use a minimal set of cookies and behavioural events to make decisions personal and improve the engine. No ads, no third-party trackers.
          </p>
          <div className="flex items-center gap-2">
            <button
              onClick={() => choose("accepted")}
              className="flex-1 py-2 rounded-lg bg-primary text-primary-foreground text-xs font-body font-medium hover:opacity-90 transition-opacity"
            >
              Accept
            </button>
            <button
              onClick={() => choose("essential")}
              className="flex-1 py-2 rounded-lg border border-border/60 text-foreground text-xs font-body hover:bg-muted/30 transition-colors"
            >
              Essential only
            </button>
          </div>
          <Link to="/privacy" className="block mt-2 text-[10px] text-muted-foreground/60 font-body hover:text-muted-foreground text-center">
            Read privacy policy
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
